<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { SubSurveysManagerDialogViewModel } from "@Evaluation/CriteriaSurveys/Components/SubSurveysManagerDialog";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class SubSurveysManagerDialog extends Vue
    {
        get vm(): SubSurveysManagerDialogViewModel { return this.$props.viewModel as SubSurveysManagerDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get initialized() { return this.vm.rm != null; }
        get masterSurveyId() { return this.vm.masterSurveyId; }
        get masterSurveyName() { return this.vm.masterSurveyName; }
        get entries() { return this.vm.rm?.Entries; }


        emitIncludeSubSurvey(surveyId: number, voteStrength: number)
        {
            const s = this.entries.find(a => a.Id === surveyId);

            if (s.IsIncluded === false)
            {
                this.$emit('include-sub-survey', this.masterSurveyId, surveyId, voteStrength);
            }
            else if (s.IsIncluded === true && s.VoteStrength !== voteStrength)
            {
                this.$emit('change-vote-strength', this.masterSurveyId, surveyId, voteStrength);
            }
        }

        emitExcludeSubSurvey(surveyId: number)
        {
            const s = this.entries.find(a => a.Id === surveyId);

            if (s.IsIncluded === true)
            {
                this.$emit('exclude-sub-survey', this.masterSurveyId, surveyId);
            }
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened === true">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content" style="height: calc(100vh - 50px);">
                    <div class="modal-header">
                        <h5 class="modal-title">Combined panels</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h2 v-if="initialized === false"><i class="fa fa-spinner fa-spin"></i> Loading...</h2>
                        <div v-if="initialized">
                            <div class="alert alert-info" role="alert">
                                You can include another panel as if it were a respondent.
                                This lets you, for example, combine and compare votes from different groups of people.
                            </div>

                            <div>
                                <table class="table table-hover">
                                    <tbody>
                                        <tr v-for="s in entries" :key="s.Id">
                                            <td>{{s.Name}}</td>
                                            <td style="width: 20%;">
                                                <div class="dropdown">
                                                    <a class="text-primary" data-toggle="dropdown">
                                                        {{ s.IsIncluded ? `Vote strength ${s.VoteStrength}` : "Not included" }}
                                                    </a>
                                                    <div class="dropdown-menu" role="menu">
                                                        <a class="dropdown-item" @click="emitExcludeSubSurvey(s.Id)">Not included</a>
                                                        <a v-for="num in 11" :key="num" class="dropdown-item" @click="emitIncludeSubSurvey(s.Id, num - 1)">
                                                            Vote strength: {{ num - 1 }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="width: 20%;">
                                                <div v-if="s.IsIncluded" class="progress" style="margin: 0;">
                                                    <div :style="{ width: s.Progress + '%' }" :title="s.Progress" class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>